import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Handoff Hub'
      breadcrumbs={[
        {
          label: 'Onboarding',
        },
        {
          label: 'Handoff Hub',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/onboarding/handoff-hub',
  component: RouteComponent,
  type: 'auth',
});
